"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("../");
exports.ROLE_NAMES = (_a = {},
    _a[_1.ORGANISATION_ADMIN_ROLE] = 'Administrator',
    _a[_1.COORDINATOR_ROLE] = 'Coordinator',
    _a[_1.CUSTOMER_COORDINATOR_ROLE] = 'Coordinator',
    _a[_1.CARER_COORDINATOR_ROLE] = 'Coordinator',
    _a[_1.CARER_ROLE] = 'Team Member',
    _a[_1.CUSTOMER_CARER_ROLE] = 'Team Member',
    _a[_1.FAMILY_ROLE] = 'Family',
    _a[_1.CUSTOMER_FAMILY_ROLE] = 'Family',
    _a.customers = 'Communities',
    _a.customer = 'Community',
    _a);
var _a;
//# sourceMappingURL=roles.js.map